import { Headphones } from "lucide-react";
import "./../css/ContactComponent.css";

const ContactComponent = () => {
    return (
        <div className="service-details-help">
            <div className="help-shape-1" />
            <div className="help-shape-2" />
            <h2 className="help-title">Contact with <br /> us for any <br /> advice</h2>
            <div className="help-icon">
                <Headphones className="w-10 h-10" />
            </div>
            <div className="help-contact">
                <p>Need help? Talk to an expert</p>
                <a href="tel:+13103736259" className="text-blue-600 hover:underline">
                    (310) 373-6259
                </a>
            </div>
        </div>
    )
}

export default ContactComponent;